import * as React from 'react';
import { SVGProps } from 'react';

const IconWifiOffSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.057 2.138a.5.5 0 0 0-.707.012L1.513 9.22a.5.5 0 0 0 .72.694L6.22 5.795l1.218-1.262.762-.789.869-.899a.5.5 0 0 0-.013-.707ZM6 3c.053 0 .106 0 .16.002L5.148 4.049A6.03 6.03 0 0 0 1.71 5.765L1 5.065A7.035 7.035 0 0 1 6 3ZM7.647 5.78l-.767.795a3.518 3.518 0 0 1 1.638.94l.709-.7a4.524 4.524 0 0 0-1.58-1.034ZM5.49 8.014l-.733.759L6 10l1.454-1.435a2.013 2.013 0 0 0-1.965-.55ZM9.463 3.9l-.718.743a6.034 6.034 0 0 1 1.546 1.122l.709-.7A7.038 7.038 0 0 0 9.463 3.9Z" />
  </svg>
);
export default IconWifiOffSizeXs;
